import NotificationActions from '../../actions/NotificationActions';
import PosActions from '../../actions/PosActions';

import UserStore from '../../stores/UserStore';

import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as PosEndPoints } from '../../constants/PosConstants';

class GLTransactionsDetails extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            details : [],
            message : false
        }

        this.loadTransaction = this.loadTransaction.bind(this);
    }

    componentDidMount() {
        this.loadTransaction();
    }

    loadTransaction() {
        var self = this;

        AjaxPromises.POST(PosEndPoints.TRANSACTION_DETAILS, UserStore.getApiData({
            TransactionId : this.props.transaction.transactionID
        })).then(res => {
            self.setState({
                details : res.Data || [],
                message : !res.Result ? 'No matching product history found' : false
            });
        });
    }

    render() {
        var self = this;

        return (
            <div className='popup popup__transparent'>
                <div className='popup__content transaction' style={{'overflow':'hidden'}}>

                    <div className='popup-header'>
                        TRANSACTION DETAILS

                        <div
                            className='popup-close'
                            onClick={() => { this.props.onClose(); }}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <div style={{'width':'100%', 'height' : 'calc(100% - 40px)', 'overflow' : 'auto'}}>

                        <table className='table-2'>
                            <thead>
                                <tr>
                                    <th>Receipt #</th>
                                    <th>Description</th>
                                    <th>SKU</th>
                                    <th>Customer</th>
                                    <th>Date</th>
                                    <th>Qty</th>
                                    <th>Grams</th>
                                    <th>Serial No</th>
                                    <th>Sold By</th>
                                    <th>Status</th>
                                    <th>Return Reason</th>
                                    <th>Return By</th>
                                    <th>Cannabis Product</th>
                                </tr>
                            </thead>
                            <tbody>

                            { this.state.details.map((x, i) => {
                                return (
                                    <tr key={'key'+i}>

                                        <td>{x.ReceiptNo}</td>
                                        <td>{x.ProductDesc}</td>
                                        <td>{x.ProductSku}</td>
                                        <td>{x.PatientName}</td>
                                        <td>{moment(x.PosDate).format('MM/DD/YYYY')}</td>
                                        <td>{x.Quantity}</td>
                                        <td>{x.ProductGrams}</td>
                                        <td>{x.SerialNo}</td>
                                        <td>{x.SoldBy}</td>
                                        <td>{x.PosStatus}</td>
                                        <td>{x.ReturnReason}</td>
                                        <td>{x.ReturnBy}</td>
                                        <td>{x.CannabisInventory}</td>
                                    </tr>
                                );
                            })}

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default GLTransactionsDetails;


// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLTransactionsDetails.react.jsx